<template>
  <div v-glossary-links>
    <Glossary />
    <div class="page-container">
      <slot name="page-header"></slot>

      <v-container class="page-content-container">
        <slot></slot>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
  import Glossary from '../components/glossary/Glossary.vue';
  import {
    useGlossaryLinks,
    vGlossaryLinks as glossaryLinksDirective,
  } from '../composables/useGlossaryLinks';

  // Set up glossary links functionality
  const glossaryLinks = useGlossaryLinks();

  // Make the directive available to the template
  const vGlossaryLinks = glossaryLinksDirective;
</script>

<style scoped lang="scss">
  .page-container {
    position: relative;
  }

  .page-content-container {
    position: relative;
    margin-top: 0;
    padding-top: 0;

    @media (min-width: 960px) {
      margin-top: -110px;
      padding-top: 76px;
    }
  }

  // Global styles for glossary links
  :deep(.glossary-link) {
    color: rgb(var(--v-theme-primary));
    text-decoration: underline;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      color: rgb(var(--v-theme-primary-darken-1));
      text-decoration: none;
    }

    &.glossary-link-active {
      background-color: rgb(var(--v-theme-primary-container));
      padding: 2px 4px;
      border-radius: 4px;
    }

    &.glossary-link-loading {
      opacity: 0.6;
      pointer-events: none;
    }
  }
</style>
